import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import { fetchImage, getFullName, twoDecimalPlaces } from "../../utils/common";
import StarRating from "../../components/rating/StarRating";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";
import UserImg from "../../../src/assets/images/providerProfileImg.png";

const JobDetailsServices = ({ details }) => {
  const [inlineItems, setInlineItems] = useState([]);
  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (details?.lineItemsData) {
        let inlineData = convertToKeyValuePairs(details?.lineItemsData);
        setInlineItems(inlineData);
      }

      if (details?.userId?.profilePic) {
        try {
          const fetchedImage = await fetchImage(details.userId.profilePic);
          setProfileImage(fetchedImage);
        } catch (error) {
          console.error("Error fetching image:", error);
        }
      } else {
        setProfileImage(UserImg);
      }
    };

    fetchData();

    return () => {
      console.log("Cleanup running on component unmount");
    };
  }, [details]);

  function convertToKeyValuePairs(jsonString) {
    try {
      // Parse the JSON string into a JavaScript object
      const arrayOfObjects = JSON.parse(jsonString);

      // Check if the parsed data is an array
      if (!Array.isArray(arrayOfObjects)) {
        console.error("Input is not an array.");
        return [];
      }

      // Use map to transform each object into an array of key-value pairs
      return arrayOfObjects
        .map((obj) => {
          // Use Object.entries to get an array of [key, value] pairs for each object
          const keyValuePairs = Object.entries(obj);

          // Use map again to transform each [key, value] pair
          const mappedPairs = keyValuePairs.map(([key, value]) => {
            // Here, you can modify or process the key and value as needed
            return { key, value };
          });

          // Return the modified object
          return mappedPairs;
        })
        .flat(); // Use flat to flatten the array of arrays
    } catch (error) {
      console.error("Error parsing JSON:", error.message);
      return [];
    }
  }

  const fetchTotalBreakdown = () => {
    let charges = 0;
    let additionalCharges = 0;
    let taxAmount = details?.taxAmount || 0;

    if (details?.fixedPrice) {
      charges = details?.fixedPrice;
    } else if (details?.durationUpdated) {
      charges = details?.unitPrice * details?.durationUpdated;
    } else if (details?.durationExpected) {
      charges = details?.unitPrice * details?.durationExpected;
    }

    if (inlineItems?.length > 0) {
      additionalCharges = inlineItems.reduce(
        (total, item) => total + parseFloat(item?.value || 0),
        0
      );
    }

    const total = charges + additionalCharges + taxAmount;

    return {
      charges: twoDecimalPlaces(charges),
      additionalCharges: twoDecimalPlaces(additionalCharges),
      taxAmount: twoDecimalPlaces(taxAmount),
      total: twoDecimalPlaces(total),
    };
  };

  const fetchTotal = () => {
    if (details?.finalPrice) {
      let price = details?.finalPrice
        ? twoDecimalPlaces(details?.finalPrice)
        : details?.finalPrice;
      return price;
    } else {
      if (details?.durationUpdated) {
        let price = details?.unitPrice * details?.durationUpdated;
        let total = price + details?.taxAmount;
        return twoDecimalPlaces(total);
      } else {
        let price = details?.unitPrice * details?.durationExpected;
        let total = price + details?.taxAmount;
        return twoDecimalPlaces(total);
      }
    }
  };

  const getDuration = () => {
    if (details?.durationUpdated) {
      return `${twoDecimalPlaces(details?.durationUpdated)} Hr`;
    } else if (details?.durationExpected) {
      return `${twoDecimalPlaces(details?.durationExpected)} Hr`;
    } else {
      return "NA";
    }
  };
  return (
    <>
      <Header />
      <PageHeading title="Job Details" />
      <div className="main-container">
        {details ? (
          <div className="container-wrap">
            <div className="job-detail-wrapper">
              <div className="job-content-wrapper">
                <div className="job-content-section">
                  <div className="box-wrapper job-content">
                    <div className="job-user-detail-wrap">
                      <div className="job-user-pic">
                        <img src={profileImage} alt="User" />
                      </div>
                      <div className="job-user-detail">
                        <div className="job-user-name">
                          {getFullName(
                            details?.userId?.firstName,
                            details?.userId?.lastName
                          )}
                        </div>
                        <div className="rating-wrap">
                          <div className="rating">
                            {" "}
                            <StarRating
                              size={20}
                              rating={details?.userId?.ratingUser}
                            />
                          </div>
                          <div className="rating-value">
                            ({details?.userId?.ratingUser || 0})
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="box-wrapper job-content mt-3">
                    <div className="job-title">
                      {getFullName(
                        details?.userId?.firstName,
                        details?.userId?.lastName
                      )}
                    </div>
                    <div className="address">{details?.userId?.email}</div>
                    <div className="phone">{details?.userId?.phone}</div>
                  </div>
                </div>
                <div className="job-content-section mt-4 mb-4">
                  <div className="job-content-titile ">Job Description</div>
                  <div className="box-wrapper job-content">
                    <div className="address">{details?.jobDetail}</div>
                  </div>
                </div>

                <div className="job-content-section mt-4 mb-4">
                  <div className="job-content-titile ">Job Location</div>
                  <div className="box-wrapper job-content">
                    <div className="address">{details?.userJobLocation}</div>
                  </div>
                </div>
                <div className="job-content-section">
                  <div className="job-content-titile">Payment Detail</div>
                  <div className="payment-detail-wrap">
                    <table className="table">
                      {parseFloat(getDuration()) > 0 && (
                        <tr>
                          <td>Time</td>
                          <td>{getDuration()}</td>
                        </tr>
                      )}

                      <tr>
                        <td width="800">
                          {details?.fixedPrice != null
                            ? "Fixed Price"
                            : "Hourly Rate"}
                        </td>
                        <td width="140">
                          {" "}
                          $
                          {details?.fixedPrice != null
                            ? details?.fixedPrice
                            : details?.unitPrice}
                        </td>
                      </tr>

                      {details?.fixedPrice > 0 && (
                        <>
                          <tr>
                            <td
                              style={{ visibility: "hidden", padding: "0px" }}
                            >
                              $$$
                            </td>
                            <td
                              colSpan="2"
                              style={{ borderTop: "1px solid #000" }}
                            ></td>
                          </tr>
                          <tr>
                            <td
                              style={{ visibility: "hidden", padding: "0px" }}
                            >
                              $$$
                            </td>
                            <td>${fetchTotalBreakdown().charges}</td>
                          </tr>
                        </>
                      )}

                      {inlineItems?.length > 0 ? (
                        <>
                          <tr>
                            <td
                              colSpan="2"
                              style={{ borderTop: "1px solid #000" }}
                            ></td>
                          </tr>
                          <tr>
                            <td
                              width="800"
                              className="text-decoration-underline"
                            >
                              Additional Charges
                            </td>
                            <td width="140"></td>
                          </tr>
                          {inlineItems?.map((item, index) => (
                            <tr key={index}>
                              <td width="800">{item?.key}</td>
                              <td width="140">${item?.value}</td>
                            </tr>
                          ))}
                        </>
                      ) : null}
                      {inlineItems?.length > 0 && (
                        <>
                          <tr>
                            <td
                              style={{ visibility: "hidden", padding: "0px" }}
                            >
                              $$$
                            </td>
                            <td
                              colSpan="2"
                              style={{ borderTop: "1px solid #000" }}
                            ></td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                visibility: "hidden",
                                paddingTop: "0px",
                              }}
                            >
                              $$$
                            </td>
                            <td>${fetchTotalBreakdown().additionalCharges}</td>
                          </tr>
                        </>
                      )}

                      {(fetchTotalBreakdown().charges > 0 ||
                        fetchTotalBreakdown().additionalCharges > 0) && (
                        <>
                          <tr>
                            <td
                              colSpan="2"
                              style={{ borderTop: "1px solid #000" }}
                            ></td>
                          </tr>

                          <tr>
                            <td width="800">Sub Total</td>
                            <td width="140">
                              $
                              {fetchTotalBreakdown().charges +
                                fetchTotalBreakdown().additionalCharges}
                            </td>
                          </tr>

                          <tr>
                            <td
                              colSpan="2"
                              style={{ borderTop: "1px solid #000" }}
                            ></td>
                          </tr>
                        </>
                      )}

                     
                      {details?.taxAmount != null && (
                        <>
                          <tr>
                            <Tooltip
                              title="The service fee consists of platform maintenance and bank fees required for secure payment processing."
                              place="top"
                            >
                              <InfoOutlineIcon style={{ marginLeft: "70px" }} />
                            </Tooltip>
                          </tr>
                          <tr>
                            <td>Service fee</td>
                            <td>{twoDecimalPlaces(details.taxAmount)}</td>
                          </tr>
                        </>
                      )}

                      {fetchTotal() > 0 && (
                        <tr>
                          <td>Total</td>
                          <td>{`$${fetchTotal()}`}</td>
                        </tr>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <Footer />
    </>
  );
};

export default JobDetailsServices;
